import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import dig from 'object-dig';

import InputTextArea from '~/components/Input/InputTextArea';
import LinearProgress from '~/components/LinearProgress';
import GridContainer from '~/components/GridContainer';
import GridItem from '~/components/GridItem';
import InputControl from '~/components/Input/InputControl';
import InputTextEditor from '~/components/Input/InputTextEditor';
import InputFile from '~/components/Input/InputFile';
import InputMultiIds from '~/components/Input/InputMultiIds';
import Typography from '@material-ui/core/Typography';

function ModalTriageRecordEvolutionForm({
  setFiles,
  loading,
  evolution,
  userPhysicalExamValue,
  userConductValue,
  handleChangeEvolutionText,  
  handleChangePhysicalExams,
  handleChangeConduct,
  handleChangeMainObject
}) {
  const { t } = useTranslation();

  return (
    <>
        <LinearProgress loading={loading} />

        <GridContainer>
            <GridItem xs={12} sm={12} md={12} lg={12} xl={12}>
            <InputControl
                value={dig(evolution, 'notes')}
                name="notes"
                label={t('medical_record_evolutions.attributes.notes')}
                inputComponent={InputTextEditor}
                onChange={handleChangeEvolutionText}
            />
            </GridItem>

            <GridItem xs={12} sm={12} md={12} lg={12} xl={12}>
                {loading && (
                    <LinearProgress style={{ height: 4 }} color="secondary" />
                )}
                <InputFile
                    label={t('dropzone_file_placeholder')}
                    onChange={(files) => setFiles(files)}
                />
            </GridItem>
        </GridContainer> 

        <LinearProgress loading={loading} />
    </>
  );
}

ModalTriageRecordEvolutionForm.propTypes = {
  loading: PropTypes.bool,
  evolution: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
};

ModalTriageRecordEvolutionForm.defaultProps = {
  loading: false,
};
export default ModalTriageRecordEvolutionForm;
